import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pb-0"
}

import { computed, onMounted, PropType, ref, watch } from "vue";

import { SECTION } from "@/constants/assets.constant";
import { showToast } from "@/services/notification-manager";
import { useContentStore } from "@/stores/content.store";

import { ContentStructureSection } from "@/models/content-structure.model";

import Collapse from "@/components/right-sidebars/ui/Collapse.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentDescription',
  props: {
  sectionId: {
    required: true,
    type: Number
  },
  productId: {
    required: true,
    type: Number
  },
  section: {
    required: true,
    type: Object as PropType<ContentStructureSection>
  },
  canEditContent: {
    required: true,
    type: Boolean
  }
},
  setup(__props) {

const contentStore = useContentStore();

const props = __props;

const title = computed<string>(() => {
  return `Description for ${props.section.name}`;
});

const instruction = ref<string>("");
onMounted(() => {
  instruction.value = props.section.instruction;
});
watch(
  () => props.section,
  newVal => {
    if (newVal) {
      instruction.value = newVal.instruction;
    }
  }
);
const saveDescriptionText = (): void => {
  contentStore
    .upsertSections({
      productIds: [props.productId],
      sections: [
        {
          id: props.sectionId,
          instruction: instruction.value
        }
      ]
    })
    .catch((error: Error) => {
      showToast({
        message: `${SECTION.ERRORS.descriptionNotUpdated}: ${error.message}`,
        type: "is-danger"
      });
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Collapse, null, {
    title: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(title.value), 1)
    ]),
    content: _withCtx(() => [
      (!__props.canEditContent)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(__props.section.instruction), 1))
        : _withDirectives((_openBlock(), _createElementBlock("textarea", {
            key: 1,
            id: "description-text",
            ref: "description-text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((instruction).value = $event)),
            onBlur: saveDescriptionText,
            "data-testing": "description"
          }, null, 544)), [
            [_vModelText, instruction.value]
          ])
    ]),
    _: 1
  }))
}
}

})